export const DEFAULT_NOTIFICATION_INTERVAL = 60000;
export const K12_ADMIN_NOTIFICATION_INTERVAL = 15000;
